'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = VeganSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VeganSvg(props) {
    var size = props.size,
        secondaryColor = props.secondaryColor,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'bgimgVegan', width: size, height: size, viewBox: '0 0 28 28', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-full-bg-vegan' },
        _react2.default.createElement(
            'title',
            { id: 'bgimgVegan' },
            ' ',
            i18n.get('openrest_menubuilderv3_dishlabels_vegan') || 'vegan'
        ),
        _react2.default.createElement(
            'g',
            { fill: 'none' },
            _react2.default.createElement('path', {
                d: 'M13.6498-.0002c-7.527 0-13.65 6.123-13.65 13.65 0 7.526 6.123 13.65 13.65 13.65 7.526 0 13.65-6.124 13.65-13.65 0-7.527-6.124-13.65-13.65-13.65',
                fill: primaryColor }),
            _react2.default.createElement('path', {
                d: 'M18.3945 8.3852c-.149 0-.278.036-.396.107-.125.074-.226.178-.306.319l-3.918 8.485-4.153-8.486c-.151-.297-.378-.441-.693-.441-.194 0-.366.059-.526.181-.157.118-.234.268-.234.458 0 .123.021.219.057.279l4.726 9.676c.073.122.17.219.29.285.119.071.252.111.405.121.133-.002.274-.041.409-.114.137-.072.244-.18.32-.321l4.715-9.635c.052-.113.078-.216.078-.306 0-.171-.072-.312-.223-.429-.16-.121-.334-.179-.551-.179',
                fill: secondaryColor })
        )
    );
}

VeganSvg.displayName = 'VeganSvg';
VeganSvg.propTypes = {
    size: _propTypes2.default.number,
    secondaryColor: _propTypes2.default.string,
    primaryColor: _propTypes2.default.string
};
VeganSvg.defaultProps = {
    size: 28,
    secondaryColor: '#fff',
    primaryColor: '#7ec77b'
};